import { Body, Dialog, ErrorIcon } from "@dbn/omnichannel-design-system-g4p";
import { RuntimeLocaleKey, useFormatMessage } from "../../intl";
import { option } from "fp-ts";

export function TabLock() {
  const formatMessage = useFormatMessage();

  return (
    <>
      <Dialog
        ariaLabelMessageForCloseIcon={formatMessage(
          "Modal.closeButton" as RuntimeLocaleKey
        )}
        icon={ErrorIcon}
        variant="center"
        size="small"
        title={formatMessage("TabLock.modalTitle")}
        onDismiss={option.none}
        actions={[]}
      >
        <Body size="medium" weight="medium">
          {formatMessage("TabLock.anotherOpenTab.label")}
        </Body>
      </Dialog>
    </>
  );
}
